<template>
    <div>
        <button type="button" @click="deletePost()">
            삭제
        </button>
    </div>
</template>

<script>
export default {
    props: {
        node: String,
        postId: Number,
        auth: String,
    },

    computed: {
        authenticated() {
            return this.auth !== ''
        },
    },

    methods: {
        async deletePost() {
            const option = {
                text: '정말 삭제할까요?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#e02424',
                confirmButtonText: '삭제합니다',
                cancelButtonText: '취소',
            }

            if (!this.authenticated) {
                option.input = 'password'
                option.inputPlaceholder = '비밀번호를 입력하세요.'
            }

            const result = await this.$swal(option)

            if (!result.value) {
                return
            }

            const password = result.value

            try {
                const response = await axios.delete(
                    `/posts/${this.node}/${this.postId}`,
                    { data: { password } }
                )
                location.href = `/posts/${this.node}`
            } catch (error) {
                this.toast(error.response.data.message, 'error', 5000)
            }
        },

        toast(message, type, timer) {
            this.$swal({
                text: message,
                icon: type || 'success',
                confirmButtonText: '확인',
                timer: timer || 3000,
            })
        },
    },
}
</script>
